module.exports = __webpack_public_path__ + "img/3-2.78fdd1df.svg";